import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './styling/admin.css';
import './styling/cart.css';
import './styling/checkout.css';
import './styling/footer.css';
import './styling/header.css';
import './styling/products_archive.css';
import './styling/single_product.css';
import './styling/questions.css';
import './styling/about.css';
import './styling/home.css';
import './styling/contacts.css';
import './styling/instrukcija.css';
import './styling/noteikumi.css';
import './styling/global.css';
import './styling/review.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);